module.exports = __webpack_public_path__ + "static/media/stack-overflow.e504f144.svg";